export const baseWidgetUrl = 'https://app.ramp.network/';

export const SEND_CRYPTO_SUPPORTED_VERSION = 1 as const;

// It will be evaluated by rollup-plugin-version-injector
export const SDK_VERSION = '[VI]{version}[/VI]';
